(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const openButtons = document.querySelectorAll('[data-cart-open]');
  const closeButtons = document.querySelectorAll('[data-cart-close]');
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  const openCart = () => drawer && drawer.classList.add('is-open');
  const closeCart = () => drawer && drawer.classList.remove('is-open');
  openButtons.forEach(b => b.addEventListener('click', openCart));
  closeButtons.forEach(b => b.addEventListener('click', closeCart));

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(open));
    });
  }

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const items = document.querySelector('[data-cart-items]');
    if (!items) return;
    items.innerHTML = cart.items.length ? cart.items.map(item => `
      <div class="cart-item">
        <img src="${item.image || ''}" alt="${item.product_title.replace(/"/g,'&quot;')}">
        <div>
          <a href="${item.url}"><strong>${item.product_title}</strong></a>
          <div>${item.final_line_price ? (item.final_line_price/100).toFixed(2) : '0.00'} €</div>
          <div class="quantity">
            <button type="button" data-change="${item.key}" data-qty="${item.quantity - 1}" aria-label="Reducir cantidad">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-change="${item.key}" data-qty="${item.quantity + 1}" aria-label="Aumentar cantidad">+</button>
          </div>
        </div>
        <button type="button" data-change="${item.key}" data-qty="0" aria-label="Eliminar ${item.product_title}">×</button>
      </div>`).join('') : '<p>Tu carrito está vacío.</p>';
    items.querySelectorAll('[data-change]').forEach(b => b.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:b.dataset.change, quantity:Number(b.dataset.qty)})
      });
      await refreshCart();
    }));
  }

  document.querySelectorAll('[data-quick-add]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const button = form.querySelector('button');
      button.disabled = true;
      try {
        const fd = new FormData(form);
        await fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}});
        await refreshCart();
        openCart();
      } finally { button.disabled = false; }
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      try {
        await fetch('/cart/add.js', {method:'POST', body:new FormData(form), headers:{'Accept':'application/json'}});
        await refreshCart();
        openCart();
      } finally { button.disabled = false; }
    });
  });

  refreshCart().catch(() => {});
})();